import { ChangeEvent, FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { Icon } from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont';

import { FormTextField } from 'src/components/FormTextField/FormTextField';
import { adminActions } from 'src/store/admin/slice';
import { getIsDesktop } from 'src/store/agent/selectors';
import { useAppDispatch } from 'src/store/useAppDispatch';

export interface TitleFieldProps {
  label?: string;
}

export const TitleField: FC<TitleFieldProps> = ({ label }) => {
  const isDesktop = useSelector(getIsDesktop);
  const dispatch = useAppDispatch();

  const changeTitle = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      dispatch(adminActions.update({ title: e.target.value }));
    },
    [dispatch],
  );

  return (
    <FormTextField
      name='title'
      onChange={changeTitle}
      size='medium'
      label={label}
      fullWidth
      dataTestId='administratorRoomTitle'
      startAdornment={<Icon iconName={Icons.InfoCircled} />}
      required
      autoFocus={isDesktop}
    />
  );
};
